// extracted by mini-css-extract-plugin
export default {"answer":"faa-z","bestAnswerHeading":"gaa-z","meta":"haa-z"};